<div class="d-flex justify-content-end p-1">
  <button mat-flat-button color="primary" type="button" (click)="addPolicy()" [disabled]="!canAddPolicy()">Aggiungi Policy</button>
</div>

@if (policies.length) {
<table mat-table [dataSource]="policies" class="mat-elevation-z0 w-100">
  <!-- Nome -->
  <ng-container matColumnDef="nome">
    <th mat-header-cell *matHeaderCellDef>Nome</th>
    <td mat-cell *matCellDef="let policy; let i = index" ngForm #form="ngForm">
      @if (!canEditPolicyName(policy)) {
      <span>{{ policy.name }}</span>
      } @if (canEditPolicyName(policy)) {
      <mat-form-field class="w-100">
        <mat-label>Nome</mat-label>
        <input matInput name="name" type="text" maxlength="255" [(ngModel)]="policy.name" #nameModel="ngModel" />
        <mat-error appFormFieldError [formFieldModel]="nameModel" [form]="form"></mat-error>
      </mat-form-field>
      } @if (policy.voucherId) {
      <mat-chip-option class="ml-2 chip-small bg-grey text-white" [disableRipple]="true" [selectable]="false">Voucher</mat-chip-option>
      } @if (policy.voucherId && policy.overwriteMode === 'OVERWRITE') {
      <mat-chip-option class="ml-2 chip-small bg-warn text-white" [disableRipple]="true" [selectable]="false">Sovrascritto</mat-chip-option>
      } @if (policy.voucherId && policy.overwriteMode === 'ADD') {
      <mat-chip-option class="ml-2 chip-small bg-grey text-white" [disableRipple]="true" [selectable]="false">Modificato</mat-chip-option>
      } @if (policy.voucherId && policy.overwriteMode === 'REMOVE') {
      <mat-chip-option class="ml-2 chip-small bg-error text-white" [disableRipple]="true" [selectable]="false">Rimosso</mat-chip-option>
      } @if (policy.licenseInstanceId && policy.overwriteMode === 'ADD') {
      <mat-chip-option class="ml-2 chip-small bg-error text-white" [disableRipple]="true" [selectable]="false">Aggiunto</mat-chip-option>
      }
    </td>
  </ng-container>
  <!-- Tipo -->
  <ng-container matColumnDef="tipo">
    <th mat-header-cell *matHeaderCellDef>Tipo</th>
    <td mat-cell *matCellDef="let policy">{{ policy.implementation.name }}</td>
  </ng-container>
  <!-- Indicatori -->
  <ng-container matColumnDef="indicatori">
    <th mat-header-cell *matHeaderCellDef>Indicatori</th>
    <td mat-cell *matCellDef="let policy; let index = index" ngForm #form="ngForm">
      <app-policy-cfg
        name="configuration"
        [(ngModel)]="policies[index]"
        [editMode]="isEditingPolicy(policy)"
        [viewMode]="'inline'"
        [showActual]="true"
        [topForm]="form"
        size="sm"
      ></app-policy-cfg>
    </td>
  </ng-container>
  <!-- Azioni -->
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let policy" ngForm #form="ngForm">
      <div class="d-flex align-items-center justify-content-end">
        @if (policy.editable && !isEditingPolicy(policy)) {
        <button mat-icon-button matTooltip="Modifica" (click)="startPolicyEditing(policy, 'ADD')">
          <mat-icon>edit</mat-icon>
        </button>
        } @if (policy.editable && policy.voucherId && !isEditingPolicy(policy)) {
        <button mat-icon-button matTooltip="Sovrascrivi" (click)="startPolicyEditing(policy, 'OVERWRITE')">
          <mat-icon>shuffle</mat-icon>
        </button>
        } @if (isEditingPolicy(policy)) {
        <button mat-icon-button matTooltip="Salva" (click)="stopPolicyEditing(policy, form)">
          <mat-icon>check</mat-icon>
        </button>
        } @if (policy.deletable) {
        <button mat-icon-button matTooltip="Rimuovi" (click)="removePolicy(policy)">
          <mat-icon>remove</mat-icon>
        </button>
        } @if (policy.recoverable) {
        <button mat-icon-button matTooltip="Ripristina" (click)="recoverPolicy(policy)">
          <mat-icon>add</mat-icon>
        </button>
        }
      </div>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
}

<table class="table table-hover">
  <tbody>
    @for (row of policies; track row; let $$index = $index) {
    <tr ngForm #form="ngForm" [ngClass]="getPolicyRowClass(row)"></tr>
    }
  </tbody>
</table>
